export const chatbotKnowledge = {
  "what are the service times?":
    "Our services are on Sundays at 9:00 AM, 11:00 AM, and 5:00 PM. We'd love to have you join us!",
  "where are you located?":
    "You can find our address and directions on our Location page. Visit our website's 'Location' section for a map and details.",
  "do you have a kids program?":
    "Yes! City Church Kids is our vibrant program for children from birth through 5th grade. Visit the City Church Kids page to learn more.",
  "how can i join a small group?":
    "Small groups are a great way to connect! You can find information and sign up on our 'Next Steps' page.",
  "how can i give?":
    "You can give online through our website, via text, or during our weekend services. Visit the 'Give' page for all the details.",
  "what events are coming up?":
    "Check out our 'News & Events' page for a full list of upcoming events, activities, and special services.",
  "how do i volunteer?":
    "We'd love your help! Visit the 'Next Steps' or 'Contact Us' page to find volunteer opportunities and get connected with a ministry team.",
  "what is the city church?":
    "The City Church is a community of believers committed to growing in faith, loving one another, and making a difference in our city and beyond.",
  "do you have parking?":
    "Yes, we have free parking available at all our locations. Volunteers are usually on-site to help direct you.",
  "how can i contact the church?":
    "You can reach us through the 'Contact Us' page on our website. We'd love to hear from you!",
  "do you have a youth program?":
    "Yes! We have vibrant programs for teenagers and young adults. Check our 'News & Events' page or contact us for current schedules.",
  "what should i expect on my first visit?":
    "Expect a warm welcome! Our services include contemporary worship, a relevant message, and a friendly community. Greeters will help you find your way.",
  "do you offer prayer support?":
    "Absolutely. You can submit a prayer request through our 'Need Prayer' page, and our prayer team will lift you up.",
  "how can i partner with the church?":
    "Visit our 'Partner With Us' page to learn about partnership opportunities, missions support, and ways to give back.",
};

/**
 * Finds the best matching answer for a user's question using keyword overlap.
 * Falls back to a helpful default if no match is found.
 */
export function findBestMatch(userInput) {
  const normalized = userInput
    .toLowerCase()
    .replace(/[^\w\s]/g, "")
    .trim();

  const inputWords = normalized.split(/\s+/).filter((w) => w.length > 2);

  // Try exact match first
  for (const key of Object.keys(chatbotKnowledge)) {
    const normalizedKey = key.replace(/[^\w\s]/g, "").trim();
    if (normalized === normalizedKey) {
      return chatbotKnowledge[key];
    }
  }

  // Keyword overlap scoring
  let bestKey = null;
  let bestScore = 0;

  for (const key of Object.keys(chatbotKnowledge)) {
    const keyWords = key
      .toLowerCase()
      .replace(/[^\w\s]/g, "")
      .split(/\s+/)
      .filter((w) => w.length > 2);

    let score = 0;
    for (const word of inputWords) {
      if (keyWords.includes(word)) {
        score += 1;
      }
    }

    // Normalize by key length for fairer comparison
    const normalizedScore = keyWords.length > 0 ? score / keyWords.length : 0;

    if (normalizedScore > bestScore) {
      bestScore = normalizedScore;
      bestKey = key;
    }
  }

  if (bestScore >= 0.3 && bestKey) {
    return chatbotKnowledge[bestKey];
  }

  return "I'm not sure about that, but I'd love to help! Try asking about service times, location, kids programs, giving, events, or volunteering. You can also select a question from the dropdown.";
}
